<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="20%"
    :before-close="handleCancel"
  >
    <span>
      <el-input
        v-model="planName"
        placeholder="请输入方案名称"
        @keydown.enter.native="handleSubmit"
      />
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { updatePlanName, createWindfarmPlan } from '../service';
import to from 'await-to-js';
export default {
  props: {
    visible: {
      type: Boolean
    },
    plan: {
      type: Object
    }
  },
  data() {
    return {
      planName: '',
      loading: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.planName = this.plan?.planName;
    });
  },
  computed: {
    title() {
      return this.plan?.planId ? '修改方案' : '新建方案';
    }
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
    async handleSubmit() {
      if (!this.planName) return;
      const requestMethod = this.plan?.planId
        ? updatePlanName
        : createWindfarmPlan;
      this.loading = true;
      const [err, result] = await to(
        requestMethod({
          planId: this.plan?.planId,
          planName: this.planName,
          projectId: this.$route.query.projectId
        })
      );
      this.loading = false;
      if (!err && result.code === 0) {
        console.log(result);
        this.$message.success(result.message || '操作成功');
        this.handleCancel();
        this.$emit('saveBack', {isNewWindFarm: true,planId:result.data.planId});
      }
    }
  }
};
</script>
